import React from 'react'
import './footer.css'
const Footer = () => {
  return (
    <>
    <div className='footer'>
    <div className='topnav'>
<div className='logos'>
  <img src='https://api.iconify.design/simple-icons:w3schools.svg?color=%23ffffff'></img>
</div>
  <a href='#' className='menu-item'>PLUS</a>
    <a href='#' className='menu-item'>SPACES</a>
  <a href='#' className='menu-item'>GET CERTIFIED</a>
  <a href='#' className='menu-item'>FOR TEACHERS</a>
    <a href='#' className='menu-item'>FOR BUSINESS</a>
  <a href='#' className='menu-item'>CONTACT US</a>
</div>
<div class='tutorial-container'>
  <div class='tutorial-column'>
    <h3>Top Tutorial</h3>
    <ul>
      <li><a href='#'>HTML Tutorial</a></li>
      <li><a href='#'>CSS Tutorial</a></li>
      <li><a href='#'>JavaScript Tutorial</a></li>
      <li><a href='#'>How To Tutorial</a></li>
      <li><a href='#'>SQL Tutorial</a></li>
      <li><a href='#'>Python Tutorial</a></li>
      <li><a href='#'>W3.CSS Tutorial</a></li>
      <li><a href='#'>Bootstrap Tutorial</a></li>
      <li><a href='#'>PHP Tutorial</a></li>
      <li><a href='#'>Java Tutorial</a></li>
      <li><a href='#'>C++ Tutorial</a></li>
      <li><a href='#'>jQuery Tutorial</a></li>
    </ul>
  </div>

  <div class='tutorial-column'>
    <h3>Top References</h3>
    <ul>
      <li><a href='#'>HTML Reference</a></li>
      <li><a href='#'>CSS Reference</a></li>
      <li><a href='#'>JavaScript Reference</a></li>
      <li><a href='#'>SQL Reference</a></li>
      <li><a href='#'>Python Reference</a></li>
      <li><a href='#'>W3.CSS Reference</a></li>
      <li><a href='#'>Bootstrap Reference</a></li>
      <li><a href='#'>PHP Reference</a></li>
      <li><a href='#'>HTML Colors</a></li>
      <li><a href='#'>Java Reference</a></li>
      <li><a href='#'>Angular Reference</a></li>
      <li><a href='#'>jQuery Reference</a></li>
    </ul>
  </div>
<div class='tutorial-column'>
    <h3>Top Examples</h3>
    <ul>
      <li><a href='#'>HTML Examples</a></li>
      <li><a href='#'>CSS Examples</a></li>
      <li><a href='#'>JavaScript Examples</a></li>
      <li><a href='#'>How To Examples</a></li>
      <li><a href='#'>SQL Examples</a></li>
      <li><a href='#'>Python Examples</a></li>
      <li><a href='#'>W3.CSS Examples</a></li>
      <li><a href='#'>Bootstrap Examples</a></li>
      <li><a href='#'>PHP Examples</a></li>
      <li><a href='#'>Java Examples</a></li>
      <li><a href='#'>XML Examples</a></li>
      <li><a href='#'>jQuery Examples</a></li>
    </ul>
  </div>
  <div class='tutorial-column'>
    <h3>Get Certified</h3>
    <ul>
      <li><a href='#'>HTML Certificate</a></li>
      <li><a href='#'>CSS Certificate</a></li>
      <li><a href='#'>JavaScript Certificate</a></li>
      <li><a href='#'>FrontEnd Certificate</a></li>
      <li><a href='#'>SQL Certificate</a></li>
      <li><a href='#'>Python Certificate</a></li>
      <li><a href='#'>PHP Certificate</a></li>
      <li><a href='#'>jQuery Certificate</a></li>
      <li><a href='#'>Java Certificate</a></li>
      <li><a href='#'>C++ Certificate</a></li>
      <li><a href='#'>C# Certificate</a></li>
      <li><a href='#'>XML Certificate</a></li>
    </ul>
  </div>
</div>
<div className='footer-icons'>
  <img  className='footer-image' src='https://api.iconify.design/tdesign:logo-youtube-filled.svg?color=%23ffffff'></img>
  <img  className='footer-image' src='https://api.iconify.design/mdi:linkedin.svg?color=%23ffffff'></img>
  <img  className='footer-image' src='https://api.iconify.design/akar-icons:discord-fill.svg?color=%23ffffff'></img>
  <img  className='footer-image' src='https://api.iconify.design/mdi:facebook-box.svg?color=%23ffffff'></img>
   <img className='footer-image' src='https://api.iconify.design/lucide:instagram.svg?color=%23ffffff'></img>
  <span className='footer-span'>FORUM</span>
  <span className='footer-span'>ABOUT</span>
  <span className='footer-span'>ACADEMY</span>
</div>
<div className='footer-subText'>
  <p>
W3Schools is optimized for learning and training. Examples might be simplified to improve reading and learning.
Tutorials, references, and examples are constantly reviewed to avoid<br></br>
 errors, but we cannot warrant full correctness
of all content. While using W3Schools, you agree to have read and accepted our 
 <span className='underline-text'>  terms of use,cookie and privacy policy</span></p>
 <p><span className='underline-text'>Copyright 1999-2025</span> by Refsnes Data. All Rights Reserved.
 <span className='underline-text'>W3Schools is Powered by W3.CSS</span></p>
</div>
</div>
    </>
  );
}

export default Footer;